<template>
	<div class="dashboard-container">
		<div v-if="tabable && tabs.length" class="tabs-group">
			<span
				v-for="tab in tabs"
				:key="tab.id"
				class="heading-3 tab"
				:class="{ 'tab--active': activeTab === tab.id }"
				@click="updateVisibleTab(tab.id)"
				>{{ tab.title }}</span
			>
		</div>
		<h3 v-else-if="title" class="title">
			{{ title }}
			<div v-if="numberMsg">({{ numberMsg }})</div>
		</h3>
		<div class="dashboard-wrapper">
			<slot></slot>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
			default: null,
			required: false
		},
		numberMsg: {
			type: Number,
			default: null
		},
		tabable: {
			type: Boolean,
			default: false
		},
		tabOptions: {
			type: Array,
			default: () => []
		},
		activeTab: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			tabs: []
		};
	},
	watch: {
		tabOptions(values) {
			this.tabs = values;
		}
	},
	mounted() {
		this.tabs = this.tabOptions;
	},
	methods: {
		updateVisibleTab(id) {
			if (this.tabable) {
				this.$emit('selectedTab', id);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.dashboard-container {
	margin: auto;
	max-width: 1000px;

	h3 {
		margin-top: 16px;
		width: 100%;
		margin: auto;
		margin-bottom: 8px;
		display: flex;
	}

	.tabs-group {
		margin-bottom: 8px;
	}

	.tab {
		margin-right: 8px;
		&:hover {
			cursor: pointer;
			text-decoration: underline;
			text-decoration-color: $hover-state;
			text-decoration-thickness: 2px;
			text-underline-offset: 4px;
		}

		&--active {
			text-decoration: underline;
			text-decoration-color: $primary-state;
			text-decoration-thickness: 2px;
			text-underline-offset: 4px;
		}
	}

	.dashboard-wrapper {
		position: relative;
		font-family: 'RobotoRegular';
		font-size: 15px;
		letter-spacing: 0.5px;
		background-color: $container-bgcolor;
		color: $questionnaire-color;
		border: 1px solid $container-border;
		border-radius: 8px;
		box-shadow: 0 15px 30px 0 rgba(0, 76, 208, 0.24);
		padding-bottom: 4px;

		@media (min-width: $breakpoint-mid) {
			font-size: 18px;
			line-height: 26px;
		}
	}
}
</style>
